import Dashboard from '../layouts/Admin/Dashboard/Dashboard';
import FeeSetting from '../layouts/Admin/FeeSetting/FeeSetting';
import Loan from '../layouts/Admin/Loan/Loan';
import AdminProfile from '../layouts/Admin/AdminProfile/AdminProfile';
import UserManagement from '../layouts/Admin/UserManagement/UserManagement';
import CatalogueArtefacts from '../layouts/Admin/CatalogueArtefacts/CatalogueArtefacts';
import CreateArtefacts from '../layouts/Admin/CatalogueArtefacts/CreateArtefacts';
import ArtefactDetail from '../layouts/Admin/CatalogueArtefacts/ArtefactDetail';
import UserList from '../layouts/Admin/Curators/UserList';
import AcquisitionMain from '../layouts/Admin/Acquisition/AcquisitionMain';
import AddAcquisition from '../layouts/Admin/Acquisition/AddAcquisition';
import AcquisitionDetail from '../layouts/Admin/Acquisition/AcquisitionDetail';
import ArtifactManagement from '../layouts/Admin/ArtifactManagement/ArtifactManagement';
import DeaccessionCreate from '../layouts/Admin/Deaccession/DeaccessionCreate';
import DeaccessionDetail from '../layouts/Admin/Deaccession/DeaccessionDetail';
import DeaccessionUpdate from '../layouts/Admin/Deaccession/DeaccessionEdit/DeaccessionUpdate';
import LoanRequest from '../layouts/Admin/Loan/LoanRequest';
import LoanDetail from '../layouts/Admin/Loan/LoanDetail';
import LoanUpdate from '../layouts/Admin/Loan/LoanEdit/LoanUpdate';
import ConservationMain from '../layouts/Admin/Conservation/ConservationMain';
import AddConservation from '../layouts/Admin/Conservation/AddConservation';
import ConservationDetail from '../layouts/Admin/Conservation/ConservationDetail';
import ReportsMain from '../layouts/Admin/Reports/ReportsMain';
import AddTransferCatalog from '../layouts/Admin/TransferCatalogue/AddTransferCatalog';
import ResearchMaterials from '../layouts/Admin/ResearchMaterials/ResearchMaterials';
import TransferDetail from '../layouts/Admin/TransferCatalogue/TransferDetail';
import TransferCatalogueMain from '../layouts/Admin/TransferCatalogue/TransferCatalogueMain';
import DeaccessionMain from '../layouts/Admin/Deaccession/DeaccessionMain';
import ConservationUpdate from '../layouts/Admin/Conservation/ConservationEdit/ConservationUpdate';
import TransferUpdate from '../layouts/Admin/TransferCatalogue/TransferEdit/TransferUpdate';
import TicketDetail from '../layouts/Admin/Receptionist/TicketDetail';
import MainFrontDesk from "../layouts/Admin/Receptionist/Main";
import MasterDataMain from "../layouts/Admin/MasterData/MasterDataMain";
import MasterDataDetailsPage from "../layouts/Admin/MasterData/pages/MasterDataDetailsPage";
import TicketManagementMain from "../layouts/Admin/TicketManagement/TicketManagementMain";
import TicketTypeDetailsPage from "../layouts/Admin/TicketManagement/pages/TicketTypeDetailsPage";
import ExhibitionDetailsPage from "../layouts/Admin/TicketManagement/pages/ExhibitionDetailsPage";
import VisitorTypeDetailsPage from "../layouts/Admin/TicketManagement/pages/VisitorTypeDetailsPage";
import DiscountDetailsPage from "../layouts/Admin/TicketManagement/pages/DiscountDetailsPage";
import GuideDetailsPage from "../layouts/Admin/TicketManagement/pages/GuideDetailsPage";
import FeedbackMain from "../layouts/Admin/Feedback/FeedbackMain";
import Notifications from "../layouts/Admin/Notifications/Notifications";
import TemporaryExhibition from "../layouts/Admin/TemporaryExhibition/TemporaryExhibition";

export const protectedRoutes = [
  {
    primaryText: 'Admin Profile',
    path: '/management/profile',
    authorized: ['super_admin', 'museum_chief'],
    component: <AdminProfile/>
  },
  {
    primaryText: 'Museums',
    path: '/management/museums',
    authorized: [],
    component: <Dashboard/>
  },
  {
    primaryText: 'Curators',
    path: '/management/users',
    authorized: [],
    component: <UserList/>
  },
  {
    primaryText: 'Fee setting',
    path: '/management/fee',
    authorized: [],
    component: <FeeSetting/>
  },
  {
    primaryText: 'Loan',
    path: '/management/loan',
    authorized: [],
    component: <Loan/>
  },
  {
    primaryText: 'Loan',
    path: '/management/loan/loan-request',
    authorized: [],
    component: <LoanRequest/>
  },
  {
    primaryText: 'Loan Detail',
    path: '/management/artifact-managements/:id',
    authorized: [],
    component: <LoanDetail/>
  },
  {
    primaryText: 'Loan Update',
    path: '/management/artifact-managements/loan-update',
    authorized: [],
    component: <LoanUpdate/>
  },
  {
    primaryText: 'Deaccession',
    path: '/management/deaccession',
    authorized: [],
    component: <DeaccessionMain/>
  },
  {
    primaryText: 'Transfer Main',
    path: '/management/transfer-list',
    authorized: [],
    component: <TransferCatalogueMain/>
  },
  {
    primaryText: 'Transfer Update',
    path: '/management/transfers/transfer-update',
    authorized: [],
    component: <TransferUpdate/>
  },
  {
    primaryText: 'User Management',
    path: '/management/user-management',
    authorized: [],
    component: <UserManagement/>
  },
  {
    primaryText: 'Acquisition',
    path: '/management/acquisition',
    authorized: [],
    component: <AcquisitionMain/>
  },
  {
    primaryText: 'Add Acquisition',
    path: '/management/acquisitions/create',
    authorized: [],
    component: <AddAcquisition/>
  },
  {
    primaryText: 'Ticketing',
    path: '/management/ticketing',
    authorized: [],
    component: <TicketDetail/>
  },
  {
    primaryText: 'Acquisition Detail',
    path: '/management/acquisitions/:id',
    authorized: [],
    component: <AcquisitionDetail/>
  },
  {
    primaryText: 'Catalogue artefacts',
    path: '/management/catalogue-artefacts',
    authorized: [],
    component: <CatalogueArtefacts/>
  },
  {
    primaryText: 'Artifact Management',
    path: '/management/artifact-managements',
    authorized: [],
    component: <ArtifactManagement/>
  },
  {
    primaryText: 'Deaccession List',
    path: '/management/artifact-managements/deaccession-create',
    authorized: [],
    component: <DeaccessionCreate/>
  },
  {
    primaryText: 'Deaccession edit',
    path: '/management/artifact-managements/deaccession-update',
    authorized: [],
    component: <DeaccessionUpdate/>
  },
  {
    primaryText: 'Deaccession Detail',
    path: '/management/deaccessions/:id',
    authorized: [],
    component: <DeaccessionDetail/>
  },
  {
    primaryText: 'Create catalogue',
    path: '/management/catalogue-artefacts/create',
    authorized: [],
    component: <CreateArtefacts/>
  },
  {
    primaryText: 'Artefact detail page',
    path: '/management/catalogue-artefacts/:id',
    authorized: [],
    component: <ArtefactDetail/>
  },
  {
    primaryText: 'Conserve Artifacts',
    path: '/management/conservator',
    authorized: [],
    component: <ConservationMain/>
  },
  {
    primaryText: 'Add Conservation Artefacts',
    path: '/management/conservator/create',
    authorized: [],
    component: <AddConservation/>
  },
  {
    primaryText: 'Conservation Detail',
    path: '/management/conservators/:id',
    authorized: [],
    component: <ConservationDetail/>
  },
  {
    primaryText: 'Conservation Update',
    path: '/management/conservators/edit',
    authorized: [],
    component: <ConservationUpdate/>
  },
  {
    primaryText: 'Transfer Request',
    path: '/management/transfers/create',
    authorized: [],
    component: <AddTransferCatalog/>
  },
  {
    primaryText: 'Transfer Detail',
    path: '/management/transfers/:id',
    authorized: [],
    component: <TransferDetail/>
  },
  {
    primaryText: 'Receptionist',
    path: '/management/fd-dashboard',
    authorized: [],
    component: <MainFrontDesk/>
  },
  {
    primaryText: 'Ticket Detail',
    path: '/management/fd-dashboard/:id',
    authorized: [],
    component: <TicketDetail/>
  },
  {
    primaryText: 'Research Material',
    path: '/management/research-material',
    authorized: [],
    component: <ResearchMaterials/>
  },
  {
    primaryText: 'Reports',
    path: '/management/reports',
    authorized: [],
    component: <ReportsMain/>
  },
  {
    primaryText: 'Master Data',
    path: '/management/master-data',
    authorized: [],
    component: <MasterDataMain/>
  },
  {
    primaryText: 'Master Data Detail',
    path: '/management/master-data/:resource/:id',
    authorized: [],
    component: <MasterDataDetailsPage/>
  },
  {
    primaryText: 'Ticket Management',
    path: '/management/ticket-management',
    authorized: [],
    component: <TicketManagementMain/>
  },
  {
    primaryText: 'Ticket Type Detail',
    path: '/management/ticket-management/:id',
    authorized: [],
    component: <TicketTypeDetailsPage/>
  },
  {
    primaryText: 'Exhibition Detail',
    path: '/management/ticket-management/exhibitions/:id',
    authorized: [],
    component: <ExhibitionDetailsPage/>
  },
  {
    primaryText: 'Visitor Type Detail',
    path: '/management/ticket-management/visitor-types/:id',
    authorized: [],
    component: <VisitorTypeDetailsPage/>
  },
  {
    primaryText: 'Discount Detail',
    path: '/management/ticket-management/discounts/:id',
    authorized: [],
    component: <DiscountDetailsPage/>
  },
  {
    primaryText: 'Guide Detail',
    path: '/management/ticket-management/guides/:id',
    authorized: [],
    component: <GuideDetailsPage/>
  },
  {
    primaryText: 'Feedback',
    path: '/management/feedback',
    authorized: [],
    component: <FeedbackMain/>
  },
  {
    primaryText: 'Notifications',
    path: '/management/notifications',
    authorized: [],
    component: <Notifications/>
  },
  {
    primaryText: 'Temporary Exhibition',
    path: '/management/temporary-exhibition',
    authorized: ['assistant', 'receptionist'],
    component: <TemporaryExhibition/>
  }
];
